/** Context copy only; live target/resource values remain owned by each scene. */
export function setHudContext(mode:'travel'|'combat',doc:Document=document):void{
 doc.body.dataset.hudContext=mode;
 const objective=doc.querySelector<HTMLElement>('.hud-objective');if(!objective)return;
 objective.setAttribute('aria-label',mode==='travel'?'การเดินทางและสำรวจ':'เป้าหมายการล่า');
 const title=objective.querySelector('b'),hint=objective.querySelector('span');
 if(title)title.textContent=mode==='travel'?'การเดินทางและสำรวจ':'เป้าหมายการล่า';
 if(hint)hint.textContent=mode==='travel'?'สำรวจพื้นที่ · คุยกับชาวเมืองเมื่ออยู่ใกล้':'เตรียมวิชา · หลบเขตอันตราย';
}
